<template>
	<ValidationProvider class="is-block is-relative" :vid="vid" :name="$attrs.label" :rules="rules" v-slot="{ errors, valid }">
		<b-field :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
			<template #label>
				<span v-html="textLabel(label, rules)"></span>
			</template>
			<b-select :id="`field-${name ? name : slugify(label)}`" v-model="innerValue" :tabindex="tab" :size="size" :icon="icon" :name="name" v-bind="$attrs">
				<option disabled="disabled" hidden="hidden" value="">{{ $tc('labels.select') }}</option>
				<slot />
			</b-select>
		</b-field>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import '@/mixins/generic'

export default {
	components: {
		ValidationProvider
	},
	props: {
		vid: {
			type: Number
		},
		tab: {
			type: [String, Number],
			default: 1
		},
		label: {
			type: String,
			default: ''
		},
		size: {
			type: String,
			default: ''
		},
		name: {
			type: [Boolean, String],
			default: false
		},
		icon: {
			type: String,
			default: ''
		},
		rules: {
			type: [Object, String],
			default: ''
		},
		// must be included in props
		value: {
			type: null
		}
	},
	data: () => ({
		innerValue: ''
	}),
	methods: {
		textLabel (label, rules) {
			let required = rules.includes('required')
			return required ? `${label} <span class="required">*</span>` : label
		}
	},
	watch: {
		// Handles internal model changes.
		innerValue(newVal) {
			this.$emit('input', newVal)
		},
		// Handles external model changes.
		value(newVal) {
			this.innerValue = newVal
		}
	},
	created() {
		if (this.value) {
			this.innerValue = this.value
			// console.log(this.innerValue)
		}
	}
}
</script>
